<template>
  <v-dialog 
    v-model="dialog"
    @click:outside="$emit('update:activated', false)"
    max-width="900" 
    scrollable
  >
    <v-card>
      <v-card-title class="headline">Selecionar Predição de Baixas:</v-card-title>
      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            label="Procurar"
            hide-details
            single-line
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="itemsPerPage"
            :search.sync="search"
            :page.sync="currentPage"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            no-data-text="Nenhuma predição de baixas disponível"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr @click="selecionarItem(row.item)">
                <td class="button cursor-pointer" style="max-width: 50px">
                  {{ row.item.id }}
                </td>
                <td class="button cursor-pointer" style="max-width: 180px">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <div class="text-truncate" v-bind="attrs" v-on="on">
                      {{ row.item.titulo }}
                    </div>
                    </template>
                    <span>{{ row.item.titulo }}</span>
                  </v-tooltip>
                </td>
                <td class="button cursor-pointer" style="max-width: 60px">
                  {{ row.item.precisao }}
                </td>
                <td class="button cursor-pointer" style="max-width: 60px">
                  {{ row.item.base }}
                </td>
                <td class="button cursor-pointer" style="max-width: 70px">
                  {{ row.item.cenario_vinculado ? (JSON.parse(row.item.cenario_vinculado)).titulo : '-' }}
                </td>
                <td class="button cursor-pointer" style="max-width: 60px">
                  {{ row.item.data_base | formatToMonth }}
                </td>
                <td class="button cursor-pointer" style="max-width: 60px">
                  {{ row.item.data_execucao | parseToDateTimeBR }}
                </td>
              </tr>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getAll()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar as predições de baixas</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import PredicoesBaixasService from '@/services/PredicoesBaixasService'

export default {
  props: {
    activated: {
      type: Boolean,
      required: true
    },
    filtroBase: {
      type: String,
      required: false,
      default: null
    },
    filtroDataBase: {
      type: String,
      required: false,
      default: null
    },
    filtroCenarioVinculado: {
      type: Boolean,
      required: false,
      default: null
    }
  },

  created() {
    this.getAll();
  },

  data: () => ({
    currentPage: 1,
    itemsPerPage: 5,
    search: undefined,
    headers: [
      {
        text: '#',
        value: 'id'
      },
      {
        text: 'Título',
        value: 'titulo'
      },
      {
        text: 'Precisão',
        value: 'precisao'
      },
      {
        text: 'Base',
        value: 'base'
      },
      {
        text: 'Cenário Vinculado',
        value: 'cenario_vinculado'
      },
      {
        text: 'Data Base',
        value: 'data_base'
      },
      {
        text: 'Executado',
        value: 'data_execucao'
      }
    ],
    items: [],
    loading: false
  }),

  computed: {
    dialog() {
      return this.activated;
    }
  },

  methods: {
    getAll() {
      this.loading = true;
      this.items = [];

      PredicoesBaixasService.getByStatus('SUCESSO', this.filtroBase, this.filtroDataBase, this.filtroCenarioVinculado)
        .then(response => this.items = response.data.data)
        .catch(() => this.$toast.error('Erro ao recuperar predições de baixas.', '',{position:'topRight'}))
        .finally(() => this.loading = false);
    },

    selecionarItem(item) {
      const data = {
        id: item.id,
        titulo: item.titulo,
        data_base: this.getOnlyDateIgnoringTimestamp(item.data_base)
      };

      this.$emit("selected", data);

      setTimeout(() => { this.search = ""}, 500);
    },

    getOnlyDateIgnoringTimestamp(date) {
      if (date && date.length > 10) date = date.substr(0, 10);

      return date;
    }
  },

  watch: {
    search() {
      this.currentPage = 1;
    },
    filtroBase() { this.getAll() },
    filtroDataBase() { this.getAll() },
    filtroCenarioVinculado() { this.getAll() }
  },

  computed: {
    dialog() {
      return this.activated;
    }
  }
}
</script>

<style>
.b-valid-label {
  color: #E5502C;
  font-weight: 400;
}
</style>